<template>
  <div class="p1">
    <img
      class="r2020_logo"
      alt="r2020_logo"
      src="https://summit-img.geekpark.net/r2020/r20_logo.svg"
    />
    <img
      class="r20_union"
      alt="r20_union"
      src="https://summit-img.geekpark.net/r2020/r20_union.svg"
    />
    <img
      class="move_on"
      alt="move on"
      src="https://summit-img.geekpark.net/r2020/pc_p1_move_on.svg"
      :style="{transform:`translate3d(${moveOnImgPosition}px,0,0)`}"
    />
    <img
      class="time"
      alt="move on"
      src="https://summit-img.geekpark.net/r2020/pc_p1_time_2.svg"
      :style="{transform:`translate3d(${timeImgPosition}px,0,0)`}"
    />
    <a class="to_watch_live" href="https://space.bilibili.com/519227473/video" target="_blank">
      <img src="https://summit-img.geekpark.net/r2020/to_watch_live_2.svg" />
    </a>
  </div>
</template>

<script>
export default {
  name: "P1",
  data() {
    return { moveOnImgPosition: 0, timeImgPosition: 0, scrollHeight: 0 };
  },
  created() {
    window.addEventListener("scroll", this.handleScroll, false);
  },
  methods: {
    handleScroll() {
      const scrollHeight =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      const scrollInstance = scrollHeight - this.scrollHeight;
      this.scrollHeight = scrollHeight;
      const { left, width } = document
        .querySelector(".p1")
        .getBoundingClientRect();
      if (left <= document.body.offsetWidth && left >= -width) {
        if (
          (scrollInstance > 0 && this.moveOnImgPosition >= -width) ||
          (scrollInstance < 0 && this.moveOnImgPosition <= 0)
        ) {
          this.moveOnImgPosition -= scrollInstance / 4;
          this.timeImgPosition -= scrollInstance / 8;
        }
      }
      if (this.scrollHeight === 0) {
        this.moveOnImgPosition = 0;
        this.timeImgPosition = 0;
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style scoped lang="less">
.p1 {
  height: 100vh;
  width: 300vh;
  background: #fff url("https://summit-img.geekpark.net/r2020/pc_p1_bg_4.svg")
    no-repeat scroll center / cover;
  padding-left: 86vh;
  position: relative;
  display: flex;
  align-items: center;
  img {
    transition: transform 0.5s ease-out;
  }
}
.r2020_logo {
  position: absolute;
  top: 50px;
  left: 100px;
  height: 39vh;
  width: auto;
  z-index: 2;
}
.r20_union {
  position: absolute;
  top: 4vh;
  left: 106vh;
  height: 8vh;
  width: auto;
  z-index: 1;
}
.move_on {
  height: 70vh;
  width: auto;
  z-index: 1;
}
.time {
  height: 14vh;
  position: absolute;
  bottom: 6vh;
  left: 10vh;
  z-index: 2;
}
.to_watch_live {
  position: absolute;
  bottom: 34vh;
  left: 96px;
  z-index: 2;
  img {
    height: 10vh;
    width: auto;
  }
}
</style>